import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import styled from 'styled-components';

export const SubHeading = styled.h4`
  margin: 0 0 14px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
`;

export const SectionHeaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`;

export const WindowBadge = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: rgba(0, 0, 0, 0.45);
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const RefreshHintWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #1890ff;
  font-size: 11px;
`;

export const Section = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 22px 26px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

export const ErrorPara = styled.p`
  color: #cf1322;
  background: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 6px;
  padding: 10px 14px;
  margin: 14px 0 0;
  font-size: 13px;
`;

export const StudioLinkPara = styled.p`
  margin: 14px 0 0;
  font-size: 13px;
`;

export const RecentRunsHeader: React.FC<{ isFetching?: boolean }> = ({ isFetching }) => (
  <SectionHeaderWrap>
    <SubHeading style={{ margin: 0 }}>Recent runs</SubHeading>
    <WindowBadge>
      {isFetching && (
        <RefreshHintWrap>
          <Spin indicator={<LoadingOutlined spin style={{ fontSize: 10 }} />} size='small' />
          refreshing
        </RefreshHintWrap>
      )}
      Last 30 days
    </WindowBadge>
  </SectionHeaderWrap>
);
